const routes = [
  {
    title: 'dashboard',
    link: '/dashboard',
    start: '/dashboard',
    icon: 'feather icon-home',
  },
  {
    title: 'Hydrodrip',
    start: '/hydrodrip',
    icon: 'feather icon-command',
    children: [
      {
        title: 'Countries',
        link: '/hydrodrip/countries',
        start: '/hydrodrip/countries',
      },
      {
        title: 'Cities',
        link: '/hydrodrip/cities',
        start: '/hydrodrip/cities',
      },
      {
        title: 'HD entities',
        link: '/hydrodrip/hd_entities',
        start: '/hydrodrip/hd_entities',
      },
    ],
  },
  {
    title: 'Clients',
    start: '/clients',
    icon: 'feather icon-users',
    children: [
      {
        title: 'Clients',
        link: '/clients/clients',
        start: '/clients/clients',
      },
      {
        title: 'Consumers',
        link: '/clients/consumers',
        start: '/clients/consumers',
      },
      {
        title: 'Top Up',
        link: '/clients/top_up',
        start: '/clients/top_up',
      },
      {
        title: 'Pay Back',
        link: '/clients/paybacks',
        start: '/clients/paybacks',
      },
    ],
  },
  {
    title: 'Meters',
    start: '/meters',
    icon: 'feather icon-droplet',
    children: [
      {
        title: 'Meters',
        link: '/meters/meters',
        start: '/meters/meters',
      },
      {
        title: 'Zones',
        link: '/meters/zones',
        start: '/meters/zones',
      },

      {
        title: 'Group of Meters',
        link: '/meters/groups',
        start: '/meters/groups',
      },
    ],
  },
  {
    title: 'Hydrowallet',
    start: '/hydrowallet',
    icon: 'feather icon-credit-card',
    children: [
      {
        title: 'Subscriptions',
        link: '/hydrowallet/subscriptions',
        start: '/hydrowallet/subscriptions',
      },
      {
        title: 'Transactions',
        link: '/hydrowallet/transactions',
        start: '/hydrowallet/transactions',
      },

      {
        title: 'Water market',
        link: '/hydrowallet/water_market?s=market',
        start: '/hydrowallet/water_market?s=market',
      },
    ],
  },
  {
    title: 'Water cards',
    start: '/water_cards',
    icon: 'feather icon-credit-card',
    children: [
      {
        title: 'Restrictions',
        link: '/water_cards/restrictions',
        start: '/water_cards/restrictions',
      },
      {
        title: 'Watercards',
        link: '/water_cards/digi_cards',
        start: '/water_cards/digi_cards',
      },
      {
        title: 'Consumptions',
        link: '/water_cards/consumptions',
        start: '/water_cards/consumptions',
      },
    ],
  },
  {
    title: 'Statistics',
    start: '/statistics',
    icon: 'feather icon-bar-chart-2',
    children: [
      {
        title: 'General',
        link: '/statistics/general',
        start: '/statistics/general',
      },
      {
        title: 'Balance Sheets',
        link: '/statistics/cycle',
        start: '/statistics/cycle',
      },
      {
        title: 'Statistics',
        link: '/statistics/accounting',
        start: '/statistics/accounting',
      },
    ],
  },
  {
    title: 'Administrators',
    start: '/administrators',
    icon: 'feather icon-user',
    children: [
      {
        title: 'Permissions',
        link: '/administrators/permissions',
        start: '/administrators/permissions',
      },
      {
        title: 'Groups',
        link: '/administrators/groups',
        start: '/administrators/groups',
      },
      {
        title: 'Users',
        link: '/administrators/users',
        start: '/administrators/users',
      },
      {
        title: 'Task',
        link: '/administrators/tasks',
        start: '/administrators/tasks',
      },
    ],
  },
]

export default routes
